import React from "react";
import "./FormSuccess.scss";
import form_success_icon from "../../../assets/images/form_success_icon.svg";
import { I2cButton, I2cIcon } from "@webcomponents/i2cwebcomponents/dist/react";
import { useNavigate } from "react-router-dom";

const FormSuccess = ({ parsedData, formData }) => {
  const navigate = useNavigate();
  const formDataListing = [
    {
      text: "Program Name",
      value: parsedData?.[0]?.["0_0"]?.["pi_program_name"] || "--",
    },
    {
      text: "Program Type",
      value: formData?.form_type == 1 ? "Prepaid/Debit" : "Credit",
    },
    {
      text: "Contact Name",
      value: parsedData?.[1]?.["1_0"]?.["pd_client_name"] || "--",
    },
    {
      text: "Phone Number",
      value: parsedData?.[1]?.["1_2"]?.["ci_companyPhone"] || "--",
    },
    {
      text: "Region",
      value: parsedData?.[1]?.["1_0"]?.["pd_region"] || "",
    },
    {
      text: "Time Zone",
      value: parsedData?.[0]?.["0_0"]?.["pi_standard_time"] || "--",
    },
    {
      text: "Bank",
      value: parsedData?.[1]?.["1_2"]?.["ci_businessName"] || "--",
    },
    {
      text: "BIN",
      value: parsedData?.[3]?.["3_0"]?.["cn_bin_no"] || "--",
    },
    {
      text: "Financial Institution",
      value: parsedData?.[2]?.["2_1"]?.["cp_afi_inst_name"] || "--",
    },
  ];
  return (
    <div className="form_success_container">
      <div className="form_success_icon">
        <img src={form_success_icon} alt="" />
      </div>
      <div className="form_success_heading">
        Request Submitted Successfully!
      </div>
      <div className="form_success_sub_heading">
        Your requested project case submitted successfully.
      </div>
      <div className="form_success_inner">
        {formDataListing.map((card, index) => (
          <div key={index} className="form_success_flex">
            <div className="form_success_flex_h">{card.text}</div>
            <div className="form_success_flex_v">{card.value}</div>
          </div>
        ))}
      </div>
      <div className="form_success_btn_flex">
        <I2cButton
          size="medium"
          onClick={() => {
            navigate("/");
          }}
        >
          Back to Home
        </I2cButton>
      </div>
    </div>
  );
};

export default FormSuccess;
